import { render, staticRenderFns } from "./AllSalesDialog.vue?vue&type=template&id=58589898&scoped=true&"
import script from "./AllSalesDialog.vue?vue&type=script&lang=js&"
export * from "./AllSalesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58589898",
  null
  
)

export default component.exports